// // import Header from '../src/components/Header'
// import React, { Suspense, useEffect, useState } from "react";
// import Layout from "../src/screens/Layout";
// import Assignment from "./screens/academics/Assignment";
// import LoginTwo from "./screens/login/Login";
// import { BrowserRouter, Route, Switch, Routes } from "react-router-dom";
// import authContext from "./screens/login/GetUserStatus";

// const Login = React.lazy(() => import("./screens/login/Login"));
// "start": "set NODE_OPTIONS=--openssl-legacy-provider && react-scripts start",
// function App() {
//   let ActiveComponent;
//   const [authenticated, setAuthenticated] = useState(
//     JSON.parse(localStorage.getItem("is_logged_in")),
//   );
//   if (authenticated) {
//     ActiveComponent = (
//       <div className="App page-wrapper compact-wrapper" id="pageWrapper">
//         <Layout />
//       </div>
//     );
//   } else {
//     ActiveComponent = (
//       <BrowserRouter>
//         <Suspense fallback={<div>Loading...</div>}>
//           <Routes>
//             {/* {routes} */}
//             <Route path="/Login" element={<Login />} />
//             <Route path="*" element={<Login />} />
//           </Routes>
//         </Suspense>
//       </BrowserRouter>
//     );
//   }

//   return (
//     <authContext.Provider value={{ authenticated, setAuthenticated }}>
//       {ActiveComponent}
//     </authContext.Provider>
//   );
// }

// export default App;

// /*

// // import Header from '../src/components/Header'
// import Layout from '../src/screens/Layout'
// import Assignment from './screens/academics/Assignment';
// import LoginTwo from './screens/login/Login';


// function App() {
//   return (
//     <div className="App page-wrapper compact-wrapper" id="pageWrapper">


//       <Layout />


//     </div>
//   );
// }

// export default App;


// */







import React, { useState, useEffect } from "react";
import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
import Layout from "../src/screens/Layout";
import Login from "./screens/login/Login";
import authContext from "./screens/login/GetUserStatus";

function App() {
  const [authenticated, setAuthenticated] = useState(
    JSON.parse(localStorage.getItem("is_logged_in")) || false
  );

  return (
    <authContext.Provider value={{ authenticated, setAuthenticated }}>
      {authenticated ? (
        <div className="App page-wrapper compact-wrapper" id="pageWrapper">
          <Layout />
        </div>
      ) : (
        <BrowserRouter>
          <Routes>

            <Route path="/" element={<Login />} />
            {/* <Route path="*" element={<Login />} /> */}
          </Routes>
        </BrowserRouter>
      )}
    </authContext.Provider>
  );
}

export default App;
